import type { Logger } from '@zg-rentals/logger-base';
import type { StatController } from './statController';

export interface MetricFnInterface {
  name: string;
  amount: number;
  options?: Record<string, unknown>;
}

export interface MetricFn {
  ({ name, amount, options }: MetricFnInterface): Promise<void>;
}

export interface Reporter {
  sampleRate: number;
  reporterName: string;
  logger?: Logger;
  stats?: StatController;
  onInitialize(logger?: Logger): void;
  count: MetricFn;
  measurementWithGauges: MetricFn;
  onError<T>({ error, args }: { error: Error; args?: T }): Promise<void>;
}

export interface MonitorReporterInterface {
  reporterName: string;
  logger?: Logger;
  sampleRate?: number;
}

export abstract class MonitorReporter implements Reporter {
  readonly reporterName: string;
  logger?: Logger;
  stats?: StatController;
  sampleRate: number;

  abstract onInitialize(logger?: Logger): void;
  abstract count(args: MetricFnInterface): Promise<void>;
  abstract gauges(args: MetricFnInterface): Promise<void>;
  abstract measurementWithGauges(args: MetricFnInterface): Promise<void>;
  abstract onError<T>({ error, args }: { error: Error; args?: T }): Promise<void>;

  constructor({ reporterName, logger, sampleRate = 1 }: MonitorReporterInterface) {
    this.reporterName = reporterName;
    this.logger = logger;
    this.sampleRate = sampleRate;
  }
}
